"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = paginate;

var _range = _interopRequireDefault(require("lodash/range"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var PAGE_SLOTS = 7;
var HALF_WINDOW = 1;
var WINDOW_SIZE = 1 + HALF_WINDOW * 2;
var windowSize = WINDOW_SIZE;
var halfWindow = HALF_WINDOW;
/**
 * Add "ellipsis" pages between any pages that aren't
 * numerically adjacent to one another.
 *
 * For example, this function would take [1, 2, 4, 7, 9, 10] and
 * turn it into [1, 2, ..., 4, ..., 7, ..., 9, 10].
 */

function injectEllipses(results, page) {
  var pageNumber = page.page || 0;
  var lastItemInResults = results.length && results[results.length - 1];
  var lastPage = lastItemInResults && lastItemInResults.page || 0;

  if (pageNumber - lastPage > 1) {
    results.push({
      ellipsis: true
    });
  }

  results.push(page);
  return results;
}
/**
 * Create an array of Page objects meet the following rules:
 *  * the first page is "1"
 *  * the last page is `totalPages`
 *  * the `currentPage` will be included, as well as the pages
 *    immediately before and after `currentPage` (this is defined
 *    by the `WINDOW_SIZE`)
 *  * at most 7 (`PAGE_SLOTS`) pages will be in the results
 *  * if there are 7 or less `totalPages`, include all of the pages
 *  * if the `currentPage` is in the first 5 or last 5 pages,
 *    render all of those first or last 5 pages
 *  * fill any gaps between pages with ellipses
 *
 * The resulting Page objects will each contain the associated page
 * number, a flag indicating whether that page is the `currentPage`,
 * and a flag indicating whether the page represents an ellipsis gap.
 */


function paginate(currentPage, totalPages) {
  var pageMaker = function pageMaker(page) {
    return {
      active: page === currentPage,
      page: page,
      ellipsis: false
    };
  };

  if (totalPages <= PAGE_SLOTS) {
    // no ellipses needed
    return (0, _range.default)(1, totalPages + 1).map(pageMaker);
  }

  var left = 1;

  if (currentPage > windowSize + 1) {
    // current page is far enough from the start that there will
    // be ellipsis to its left; figure out the first number to
    // the right of the ellipsis (i.e. the "left" of the part
    // after the ellipsis)
    left = Math.min(totalPages - (windowSize + 2) + 1, currentPage - halfWindow);
  }

  var right = totalPages;

  if (currentPage < windowSize + 2) {
    // current page is near the beginning of the list and may have
    // ellipses to the right of the first chunk of pages
    right = windowSize + 2;
  } else if (currentPage <= totalPages - windowSize - halfWindow) {
    // current page is far enough from the end that there will
    // be ellipsis to its right; figure out which page will define
    // the "right" end of the zone before this ellipsis.
    right = currentPage + halfWindow;
  } // create the list of page numbers that will be in the final list,
  // removing duplicates in case the windowed area overlaps the first
  // or last page


  var pageNumbers = (0, _uniq.default)([1].concat(_toConsumableArray((0, _range.default)(left, right + 1)), [totalPages])); // make the page numbers into Page objects and add ellipses at
  // the points where page numbers are discontinuous

  return pageNumbers.map(pageMaker).reduce(injectEllipses, []);
}